function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M.941 0h7.53c.52 0 .94.421.94.941v7.53c0 .52-.42.94-.94.94H.94A.941.941 0 0 1 0 8.472V.94C0 .421.421 0 .941 0zm0 .941v7.53h7.53V.94H.94z"
}), React.createElement("path", {
  d: "M7.7 2.567a.856.856 0 1 1-1.71 0 .856.856 0 0 1 1.71 0z"
}), React.createElement("path", {
  d: "M7.7 7.7H1.712V6.418l1.747-3.85 1.997 3.208h.499L7.7 3.85z"
}), React.createElement("path", {
  d: "M11.53 0h7.529c.52 0 .941.421.941.941v7.53c0 .52-.421.94-.941.94h-7.53a.941.941 0 0 1-.94-.94V.94c0-.52.42-.941.94-.941zm0 .941v7.53h7.529V.94h-7.53z"
}), React.createElement("path", {
  d: "M18.289 2.567a.856.856 0 1 1-1.711 0 .856.856 0 0 1 1.71 0z"
}), React.createElement("path", {
  d: "M18.289 7.7h-5.99V6.418l1.747-3.85 1.997 3.208h.499l1.747-1.925z"
}), React.createElement("g", null, React.createElement("path", {
  d: "M.941 10.588h7.53c.52 0 .94.422.94.941v7.53c0 .52-.42.941-.94.941H.94A.941.941 0 0 1 0 19.059v-7.53c0-.52.421-.94.941-.94zm0 .941v7.53h7.53v-7.53H.94z"
}), React.createElement("path", {
  d: "M7.7 13.155a.856.856 0 1 1-1.71 0 .856.856 0 0 1 1.71 0z"
}), React.createElement("path", {
  d: "M7.7 18.289H1.712v-1.284l1.747-3.85 1.997 3.209h.499L7.7 14.439z"
})), React.createElement("g", null, React.createElement("path", {
  d: "M11.53 10.588h7.529c.52 0 .941.422.941.941v7.53c0 .52-.421.941-.941.941h-7.53a.941.941 0 0 1-.94-.941v-7.53c0-.52.42-.94.94-.94zm0 .941v7.53h7.529v-7.53h-7.53z"
}), React.createElement("path", {
  d: "M18.289 13.155a.856.856 0 1 1-1.711 0 .856.856 0 0 1 1.71 0z"
}), React.createElement("path", {
  d: "M18.289 18.289h-5.99v-1.284l1.747-3.85 1.997 3.209h.499l1.747-1.925z"
})));

var SvgIconBulkEdit = function SvgIconBulkEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconBulkEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bulk-edit.66a60ac8.svg";
export { ForwardRef as ReactComponent };